export const CURRENCIES = [
  { code: "NGN", symbol: "₦", name: "Nigerian Naira" },
  { code: "USD", symbol: "$", name: "US Dollar" },
  { code: "EUR", symbol: "€", name: "Euro" },
  { code: "GBP", symbol: "£", name: "British Pound" },
  { code: "GHS", symbol: "₵", name: "Ghanaian Cedi" },
  { code: "ZAR", symbol: "R", name: "South African Rand" },
  { code: "KES", symbol: "KSh", name: "Kenyan Shilling" },
  { code: "XOF", symbol: "CFA", name: "West African CFA" },
];

export function currencySymbol(code) {
  const c = CURRENCIES.find((x) => x.code === code);
  return c ? c.symbol : code;
}

export function formatMoney(amount, code = "NGN") {
  const sym = currencySymbol(code);
  const n = Number(amount || 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `${sym}${n}`;
}

export function formatNum(n, digits = 2) {
  return Number(n || 0).toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: digits,
  });
}

export const ROLE_LABELS = {
  admin: "Administrator",
  inventory_manager: "Inventory Manager",
  sales: "Sales",
  accountant: "Accountant",
  sales_accountant: "Sales / Accountant",
  super_admin: "Super Admin",
};

export const FEATURE_KEYS = [
  "raw", "products", "production", "transfers", "invoices",
  "po", "expenses", "payments", "contacts", "warehouses", "users",
];

export const FEATURE_LABELS = {
  raw: "Raw Materials",
  products: "Products (BoM)",
  production: "Production",
  transfers: "Transfers",
  invoices: "Sales Invoices",
  po: "Purchase Orders",
  expenses: "Expenses",
  payments: "Payments",
  contacts: "Contacts",
  warehouses: "Warehouses (multi)",
  users: "Users (team)",
};

export function can(role, area) {
  if (role === "admin") return true;
  const map = {
    inventory_manager: ["raw", "products", "production", "transfers", "warehouses", "po", "dashboard"],
    sales: ["invoices", "contacts", "dashboard"],
    accountant: ["invoices", "po", "expenses", "payments", "contacts", "dashboard"],
    sales_accountant: ["invoices", "po", "expenses", "payments", "contacts", "dashboard"],
  };
  return (map[role] || []).includes(area);
}
